export const SourceBadges = ({ sources }) => {
  const down = Object.entries(sources || {}).filter(([, v]) => !v.ok);
  if (!down.length) return <span className="text-[10px] text-[color:var(--green)] tracking-widest" data-testid="desk-sources-ok">ALL SOURCES LIVE</span>;
  return (
    <div className="flex flex-wrap gap-1 justify-end" data-testid="desk-sources-down">
      {down.map(([k, v]) => <span key={k} className="desk-badge" title={v.error || ""} data-testid={`desk-source-down-${k.replace(/\W+/g, "-").toLowerCase()}`}>{k} down</span>)}
    </div>
  );
};
